/*
    TokushoPage.jsx
    特定商取引法に基づく表記 - Specified Commercial Transactions Act Page
*/

import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function TokushoPage() {
    const { t } = useTranslation();

    const rows = [
        'operator', 'manager', 'address', 'contact',
        'payment', 'amount', 'additionalFees', 'delivery', 'refund'
    ];

    return (
        <div className="tokusho-page">
            <section className="tokusho-page-header">
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    {t('tokushoPage.title')}
                </motion.h1>
            </section>

            <motion.section
                className="tokusho-content"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
            >
                <table className="tokusho-table">
                    <tbody>
                        {rows.map((key) => (
                            <tr key={key}>
                                <th>{t(`tokushoPage.${key}.label`)}</th>
                                <td style={{ whiteSpace: 'pre-line' }}>
                                    {t(`tokushoPage.${key}.value`)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </motion.section>
        </div>
    );
}
